import { IconHome } from 'components/icons/home';
import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { MenuItem } from './menu-item';
import { ToggleIcon } from './toggle-icon';
import { MenuList, MenuBackdrop, MenuToggle, MobileHidden, MobileOnly } from './styled';
import { useLocale } from 'locale';

export const Menu = () => {
  const locale = useLocale();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen((v) => !v);

  return (
    <>
      <MenuToggle onClick={toggleMenu} aria-label="Toggle menu">
        <ToggleIcon />
      </MenuToggle>
      {isMenuOpen && <MenuBackdrop onClick={toggleMenu} />}
      <CSSTransition timeout={500} in={isMenuOpen}>
        <MenuList>
          <MenuItem href="/">
            <MobileHidden>
              <IconHome aria-label={locale.title} />
            </MobileHidden>
            <MobileOnly>{locale.title}</MobileOnly>
          </MenuItem>
          <MenuItem href="/send-data">{locale.menu.sendData}</MenuItem>
        </MenuList>
      </CSSTransition>
    </>
  );
};
